// @ts-nocheck
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import { ProductQuantityBreakPricingStyles } from "@insite/content-library/Components/ProductQuantityBreakPricing";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import { GridContainerProps } from "@insite/mobius/GridContainer/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyProps } from "@insite/mobius/Typography";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { lazyLoadStyles } from "@store/Themes/common/mixins/lazyload";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

interface ProductNumbersProps {
    container?: GridContainerProps;
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const productNumbers: ProductNumbersProps = {
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles([], [".5em"])}
            ${({ theme }) => `
                line-height: ${theme.design.typography.lineHeight.smaller};
                font-size: ${theme.design.typography.size.smaller};
            `}
        `,
    },
    labelText: {
        color: "text.main",
        transform: "uppercase",
        css: css`
            display: flex;
            width: auto;
            margin-right: ${pxToRem(5)};
            white-space: nowrap;
            ${({ theme }) => `
                font-weight: ${theme.design.typography.weight.base};
                font-size: ${theme.design.typography.size.smaller};
            `}
        `,
    },
    valueText: {
        color: "text.dark",
        transform: "uppercase",
        css: css`
            display: flex;
            flex-wrap: wrap;
            width: auto;
            white-space: nowrap;
            ${({ theme }) => `
                font-weight: ${theme.design.typography.weight.bold};
                font-size: ${theme.design.typography.size.smaller};
            `}
        `,
    },
};

interface ProductListProps {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
}

export const productListProps: ProductListProps = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            padding: ${pxToRem(20)};
            border: ${pxToRem(3)} solid ${getColor("common.borderLight")};
            background-color: ${getColor("common.background")};
        `,
    },
    imageWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            width: 100%;
            margin: 0 auto;
            margin-bottom: ${pxToRem(20)};
        `,
    },
};

interface ProductCardImageStyles {
    wrapper?: InjectableCss;
    productImage?: ProductImageStyles;
    compareCheckbox?: CheckboxPresentationProps;
}

export const productCardImageStyles: ProductCardImageStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
        `,
    },
    compareCheckbox: {
        css: css`
            align-self: center;
            padding-top: ${pxToRem(20)};
        `,
    },
    productImage: {
        image: {
            width: "100%",
            css: css`
                ${lazyLoadStyles()}
                img {
                    min-width: 100%;
                }
            `,
        },
    },
};

interface ProductListProductInformationStyles {
    brandStyles?: ProductBrandStyles;
    descriptionStyles?: ProductDescriptionStyles;
    productInformationWrapper?: InjectableCss;
    informationItem?: InjectableCss;
    brandWrapper?: InjectableCss;
}

export const productCardInformationStyles: ProductListProductInformationStyles = {
    descriptionStyles: {
        productDetailLink: {
            css: css`
                width: 100%;
                display: flex;
                align-items: center;

                ${breakpointValues(["0", pxToRem(64)], "min-height")}
            `,
            typographyProps: {
                color: "primary",
                forwardAs: "h2",
                variant: "h3",
            },
        },
    },
    productInformationWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
        `,
    },
    informationItem: {
        css: css`
            ${contentSpacingStyles(0, 0, ".75em")}
        `,
    },
    brandWrapper: {
        css: css`
            min-height: ${pxToRem(27)};
        `,
    },
    brandStyles: {
        nameText: {
            css: css`
                margin-bottom: 0.5em;
            `,
        },
        nameLink: {
            typographyProps: {
                css: css`
                    margin-bottom: 0.5em;
                    ${breakpointValues(["0", pxToRem(64)], "min-height")}
                    ${({ theme }) => `
                        font-weight: ${theme.design.typography.weight.base};
                        font-size: ${theme.design.typography.size.tiny};
                    `}
                `,
            },
        },
    },
};

interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartButton?: ButtonPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    rightColumn?: InjectableCss;
    leftColumn?: InjectableCss;
}

export const actionsCardStyles: ProductListActionsStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            width: 100%;
            padding-top: ${pxToRem(20)};
            margin-top: 2em;
            border-top: ${pxToRem(1)} solid ${getColor("common.border")};
        `,
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: ${pxToRem(8)} 0;
            `,
        },
    },
    addToCartButton: {
        css: css`
            ${({ theme }) => theme.button.primary.css}
            width: 100%;
        `,
        typographyProps: {
            css: css`
                white-space: nowrap;
            `,
        },
    },
    price: {
        priceWrapper: {
            css: css``,
        },
    },
    rightColumn: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-grow: 2;

            > * {
                ${contentSpacingStyles(0, 0, pxToRem(10), 0)}
            }
        `,
    },
    leftColumn: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex-grow: 1;
            min-width: 40%;
            padding-right: ${pxToRem(10)};

            > * {
                ${contentSpacingStyles(0, 0, pxToRem(10), 0)}
                min-height: 2.8em !important;
                margin: auto 0;
            }
        `,
    },
};
